import React, { useEffect, useState } from 'react'

import { deleteImage, getHostGlanceEndpoint, testHostGlance } from './actions'
import { ErrorMessage } from 'core/components/validatedForm/ErrorMessage'
import ExternalLink from 'core/components/ExternalLink'
import { routeManager } from 'core/utils/routes'
import { IHealthServiceDetailsPageTabs } from '../networks/model'
import CustomDeleteDialog from 'core/components/CustomDeleteDialog'
import Text from 'core/elements/Text'

export default function DeleteImage(props) {
  const [showWarning, setShowWarning] = useState(false)
  const [needToValidateCert, setNeedToValidateCert] = useState(false)
  const [glanceHostNotReachable, setGlanceHostNotReachable] = useState(false)

  useEffect(() => {
    const asyncCall = async () => {
      try {
        const endpoint = await getHostGlanceEndpoint()
        if (!endpoint) {
          setShowWarning(true)
        }
        await testHostGlance(endpoint)
      } catch (err) {
        if (err?.err?.message === 'Network Error') {
          setNeedToValidateCert(true)
        } else if (err?.err?.code === 'ECONNABORTED') {
          setGlanceHostNotReachable(true)
        }
      }
    }
    asyncCall()
  }, [])

  // error/info message handling
  let infoMessage: React.ReactNode | undefined
  if (needToValidateCert) {
    infoMessage = (
      <ErrorMessage>Trust the image library certificate before proceeding.</ErrorMessage>
    )
  } else if (glanceHostNotReachable) {
    infoMessage = (
      <ErrorMessage>
        <Text variant="body2">
          Image library host not reachable. Please check the image service health{' '}
          <ExternalLink
            url={routeManager.routes.openstack.health.details.path({
              tab: IHealthServiceDetailsPageTabs.ServiceHealth,
            })}
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </ExternalLink>
          .
        </Text>
      </ErrorMessage>
    )
  }

  return (
    <CustomDeleteDialog
      {...props}
      deleteAction={deleteImage}
      title="Delete Image(s)"
      resourceLabel="image(s)"
      showInfo={!!infoMessage}
      infoMessage={infoMessage}
      subTitle={
        showWarning
          ? 'You are about to delete image(s) that belong to a host without an Image Library role. This action cannot be undone.'
          : 'This will permanently delete the following image(s):'
      }
    />
  )
}
